export var DwellLoggerType;
(function (DwellLoggerType) {
    DwellLoggerType["FDP"] = "FDP";
})(DwellLoggerType || (DwellLoggerType = {}));
